const classes = {
  base: "",
  borderRadius: {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
  },
  padding: {
    none: "p-0",
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
    xl: "p-8",
  },
  shadow: {
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
    xl: "shadow-xl",
  },
  opacity: {
    0: "bg-opacity-0",
    5: "bg-opacity-5",
    10: "bg-opacity-10",
    20: "bg-opacity-20",
    30: "bg-opacity-30",
    40: "bg-opacity-40",
    50: "bg-opacity-50",
    60: "bg-opacity-60",
    70: "bg-opacity-70",
    80: "bg-opacity-80",
    90: "bg-opacity-90",
    100: "bg-opacity-100",
  },
  blur: {
    none: "",
    sm: "backdrop-blur-sm",
    md: "backdrop-blur-md",
    lg: "backdrop-blur-lg",
    xl: "backdrop-blur-xl",
    "2xl": "backdrop-blur-2xl",
  },
  backgroundColor:{
    primary:'bg-emerald-500',
    secondary:'bg-gray-800',
    tertiary:'bg-slate-300',
    white:'bg-white',
    base:'bg-amber-50'

  }
};

export default classes;
